/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {
  OverlayModule,
  PortalModule,
  A11yModule,
  MdCommonModule,
} from '../core';
import {MdDialog} from './dialog';
import {MdDialogContainer} from './dialog-container';
import {
  MdDialogClose,
  MdDialogContent,
  MdDialogTitle,
  MdDialogActions
} from './dialog-content-directives';
export class MdDialogModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
    OverlayModule,
    PortalModule,
    A11yModule,
    MdCommonModule,
  ],
  exports: [
    MdDialogContainer,
    MdDialogClose,
    MdDialogTitle,
    MdDialogContent,
    MdDialogActions,
    MdCommonModule,
  ],
  declarations: [
    MdDialogContainer,
    MdDialogClose,
    MdDialogTitle,
    MdDialogActions,
    MdDialogContent,
  ],
  providers: [
    MdDialog,
  ],
  entryComponents: [MdDialogContainer],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdDialogModule_tsickle_Closure_declarations() {
/** @type {?} */
MdDialogModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdDialogModule.ctorParameters;
}


export {MdDialog} from './dialog';
export {throwMdDialogContentAlreadyAttachedError,MdDialogContainer} from './dialog-container';
export {MdDialogClose,MdDialogTitle,MdDialogContent,MdDialogActions} from './dialog-content-directives';
export {DialogRole,DialogPosition,MdDialogConfig} from './dialog-config';
export {MdDialogRef} from './dialog-ref';
export {MD_DIALOG_DATA} from './dialog-injector';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
